module.exports = __webpack_public_path__ + "static/media/Life is Full of Options Brochure.be7bef75.pdf";